import Instagram from '../public/icons/Restantes/Instagram.svg'
import Facebook from '../public/icons/Restantes/Facebook.svg'
import Youtube from '../public/icons/Restantes/Youtube.svg'

export const Footer = () => {
    return (
        <div className="footer mt-5 d-none-celular">
            <div className="container pt-5 pb-2">
                <div className="row">
                    <div className="col-md-4 endereco-saurus">
                        <div>
                            <h4 className="title-footer">Saurus Software</h4>
                        </div>
                        <br />
                        <div>
                            <span>Rua Catigua, 159 - Sala 908</span><br />
                        </div>
                        <div>
                            <span>Tatuapé - São Paulo - SP</span>
                        </div>
                        <br />
                        <span>(11) 93925-9984</span>
                        <br /><br />
                        <span>comercial@saurus.com.br</span>
                    </div>
                    <div className="col-md-4 text-center">
                        <h4 className="title-footer">Atendimento</h4>
                        <br />
                        <span>SEG - SEX: 09:00 - 17:00</span>
                        <br /><br />
                        <h4>Siga-nos</h4>
                        <br />
                        <div className="d-flex justify-content-center">
                            <a title='Saurus' className="me-2" href="https://www.facebook.com/saurustecnologia">
                                <img src={Facebook} alt="" />
                            </a>
                            <a title='Saurus' className="me-2" href="https://www.instagram.com/saurussoftware/">
                                <img src={Instagram} alt="" />
                            </a>
                            <a title='Saurus' href="https://www.youtube.com/channel/UCK_ImdAQ7HG-papLWpPimdg">
                                <img src={Youtube} alt="" />
                            </a>
                        </div>
                    </div>
                    <div className="col-md-4 justify-content-center d-flex">
                        <div>
                            <div>
                                <span className="title-footer">Outros sistemas</span>
                            </div>
                            <br />
                            <div className="">
                                <a className="sistemas-link" href="./saurus-pdv.html">Saurus PDV</a>
                            </div>
                            <br />
                            <div className="">
                                <a className="sistemas-link" href="./saurusv4.html">Saurus V4</a>
                            </div>
                            <br />
                            <div className="">
                                <a className="sistemas-link" href="./saurus-mobile.html">Saurus Mobile</a>
                            </div>
                            <br />
                            <a className="sistemas-link" href="./touchone.html">TouchOne</a>
                        </div>
                    </div>
                </div>
                <hr className="hr-cinza footer-hr" />
                <div className="d-flex justify-content-center">
                    <span>Saurus Software © - Copyright 2023 | CNPJ: 11.914.993/0001-23</span>
                </div>
            </div>
        </div>
    )
}